import { HowMuchMarijuanaDoYouConsume } from "~/providers/utils/types/rawResponsesTypes";

export const formatHowMuchMarijuanaAnswers = (
  answer: HowMuchMarijuanaDoYouConsume[],
) =>
  answer.flatMap(({ how_much, how_many_days_a_week }) => [
    `How much in grams/dollars per week/month? ${how_much}`,
    `How many days a week do you use? ${how_many_days_a_week}`,
  ]);
